import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button, generateQeId, Input, ControlGroup } from '@ctct/ui-react';

import { useInboxPreviewContext } from './InboxPreviewContext';

const propTypes = {
  addPromo: PropTypes.func.isRequired,
};

const GetPromoInput = ({ addPromo }) => {
  const { t } = useTranslation();

  const [state, dispatch] = useInboxPreviewContext();
  const { promoError, validatingPromoCode, qeId } = state;

  const promoErrorClasses = () => classNames('error-msg', promoError ? '' : 'discount-hide');
  const promoInputClasses = () => classNames('discount-input', promoError ? 'is-invalid' : '');

  return (
    <div className="sidebar-accordion-panel-content" data-qe-id={generateQeId(qeId, 'accordion-content')}>
      <ControlGroup full>
        <Input
          autoFocus
          invalid={!!promoError}
          data-qe-id={generateQeId(qeId, 'discount-input')}
          className={promoInputClasses()}
          placeholder={t('add-inbox-preview.input-code-placeholder')}
          onChange={(event) => dispatch({ type: 'setPromoCode', value: event.target.value.trim().toUpperCase() })}
        />
        <Button
          text={t('add-inbox-preview.apply-button-text')}
          kind="plain"
          className="discount-submit-button"
          data-qe-id={generateQeId(qeId, 'discount-apply-button')}
          onClick={addPromo}
          busy={validatingPromoCode}
        />
      </ControlGroup>
      <span className={promoErrorClasses()}>{promoError}</span>
    </div>
  );
};

GetPromoInput.propTypes = propTypes;

export default GetPromoInput;
